 const en = {
    bottomNavbar : {
        listTitle : 'List',
        accountTitle : 'Account'
    },
    signup : {
        signupTitle : 'Account',
        emailPlaceholder: 'E-mail',
        emailError: 'Email must be a valid email',
        emailRequired: 'Email is a required field',
        passwordPlaceholder: 'Password',
        passwordError: 'Password must be at least 8 characters',
        passwordRequired: 'Password is a required field',
        signupBtn: 'Sign Up',
    },
    account: {
        accountTitle: 'Account',
        accountEmail : 'E-mail',
        accountPassword : 'Password',
        accountLocale : 'Current locale',
        accountLogout: 'Logout'
    },
    basket:{
        addBasket: "ADD TO BASKET",
        removeBasket : "REMOVE FROM BASKET",
        totalOfProducts : "Total of Products",
        total : "Total",
        taxCargo : "Tax + Cargo",
        generalTotal : "General Total",
        addBasketMessage : "Added to basket",
        deleteBasketMessage : "Added to basket",
        emptyBasket:"Basket is empty !",
    },
    messages: {
        signupSuccess: 'Successfully registered.',
        signupError : 'User already exist.',
    },
    locale: {
        tr:"Türkçe",
        en:"English"
    }
};

export default en;